export default {
    'event_list': '活動列表',
    'upcoming_event_list': '最近活動列表',
    'display_upcoming_event': '顯示最近活動',
    'no_events': '沒有任何活動...',
    'activities': '活動',
    'media-report': '傳媒報導'
    // Add more translations as needed
};